import { Table } from 'legacy/lut/library/list'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS } from '../../configs/translations'
import { selectMarketYoyGrowthExpectationLog } from '../../model'
import { IMarketYoyGrowthLogEntry } from '../../model/types'

import { getColumns } from './helpers/getColumns'

import styles from './MarketYoyGrowthExpectationLogTable.module.scss'

const KEYS = MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS

export const MarketYoyGrowthExpectationLogTable = () => {
  const log = useSelector(selectMarketYoyGrowthExpectationLog)
  const columns = useMemo(getColumns, [])

  const source = useMemo(
    () =>
      new Crud<IMarketYoyGrowthLogEntry, number>({
        fetcher: new Static(log),
        keyField: 'id',
        defaultSort: { field: 'created', dir: 'desc' },
        defaultPaging: { page: 0, pageSize: 5 },
      }),
    [log]
  )

  return (
    <div className={styles.tableTile}>
      <h3 className={styles.title}>
        <Translation text={KEYS.log.title} span />
      </h3>

      <Table<IMarketYoyGrowthLogEntry, number>
        header
        hasExport
        source={source}
        columns={columns}
        pagination={log.length > 5}
      />
    </div>
  )
}

MarketYoyGrowthExpectationLogTable.displayName = 'MarketYoyGrowthExpectationLogTable'
